import React, { Component } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import images from '../../assets';
import './Slider.scss';

class Slider extends Component {
    sliderImgs = [
        { label: 'hvac_' },
        { label: 'buildingAutomationServicesNew' },
        { label: 'pv' },
    ];
    render() {
        return (
            <Carousel
                autoPlay
                emulateTouch
                dynamicHeight={false}
                infiniteLoop
                stopOnHover
                showStatus={false}
                showThumbs={false}
            >
                {this.sliderImgs?.map((img) => (
                    <div
                        key={img?.label}
                        style={{
                            display: 'flex',
                            height: '100%',
                            width: '100%',
                            borderRadius: '12px',
                            overflow: 'hidden',
                        }}
                    >
                        <img
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: '12px',
                                display: 'block',
                            }}
                            src={images[img?.label]}
                            alt={img?.label}
                            loading={'lazy'}
                        />
                    </div>
                ))}
            </Carousel>
        );
    }
}

// ReactDOM.render(<Slider />, document.querySelector('.demo-carousel'));
export default Slider;
